<div class="form-page small-empty profile-details">
  <div *ngIf='dataLoading' class="dataLoading">
    <mat-spinner class="m-auto" diameter="50"></mat-spinner>
  </div>
  <div class="form-content" *ngIf='!dataLoading'>
    <div class="card mt-3 basic-info profile-details">
      <button (click)="openForm()" type="button" class="btn btn-with-icon ml-auto mr-3 mt-3" [class.invisible]="!details.canEdit">
        <mat-icon>edit</mat-icon>
      </button>
      <div class="card-head">
        <div class="user-block d-block m-auto">
          <div class="image-uploader d-block m-auto text-center">
            <div class="upload-container">
              <label>
                <div class="image-preview photo">
                  <img *ngIf="details.profilePicture" [src]="details.profilePicture"
                    (error)='details.profilePicture = ""'>
                  <span *ngIf="!details.profilePicture">{{ details.name | shortName }}</span>
                </div>
              </label>
            </div>
          </div>
          <p class="font-24 fontBold text-center">{{details.name}}</p>
          <p class="font-16 fontRegular text-center grey-color">
            <span *ngFor="let item of details.roles; index as i">
              <i *ngIf="i !== 0">,</i> {{item.name}}</span>
          </p>

        </div>

      </div>
      <div class="card-content ml-3">
        <div class="card-title mt-3">
          <div class="title font-20 fontMedium grey-color">{{'content4.Basic Information' | translate}}</div>
        </div>
        <div class="row mt-3">
          <div class="col-sm-12 col-md-6 col-lg-4 pb-5 d-flex">
            <span class="right-details">
              <p class="font-14 fontRegular grey-color">{{'forms.Email' | translate}}</p>
              <a class="font-16 fontRegular" style="color: #0370FF;" [href]="'mailto:' + details.email">{{details.email}}</a>
            </span>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4 pb-5 d-flex">
            <span class="right-details">
              <p class="font-14 fontRegular grey-color">{{'forms.Phone number' | translate}}</p>
              <a class="font-16 fontRegular" [href]="'tel:' + details.countryCode + ' ' + details.phoneNumber">
                {{details.countryCode + ' ' + details.phoneNumber}}</a>
            </span>
          </div>
          <!-- <div class="col-sm-12 col-md-6 col-lg-4 pb-5 d-flex">
            <span class="right-details">
              <p class="font-14 fontRegular grey-color">{{'forms.Address' | translate}}</p>
              <span class="font-16 fontRegular">
                {{details.address}}
              </span>
            </span>
          </div> -->
          <div class="col-sm-12 col-md-6 col-lg-4 pb-5 d-flex">
            <span class="right-details">
              <p class="font-14 fontRegular grey-color">{{'forms.Gender' | translate}}</p>
              <span class="font-16 fontRegular">{{details.gender.name}}</span>
            </span>
          </div>

          <div class="col-sm-12 col-md-6 col-lg-4 pb-5 d-flex">
            <span class="right-details">
              <p class="font-14 fontRegular grey-color">{{'forms.Date of birth' | translate}}</p>
              <span class="font-16 fontRegular">
                {{details.dateOfBirth | DateModel}}
              </span>
            </span>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4 pb-5 d-flex">
            <span class="right-details">
              <p class="font-14 fontRegular grey-color">{{'forms.Nationality' | translate}}</p>
              <span class="font-16 fontRegular">
                {{details.nationality}}
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
